import { stemSplitterSessionStorage } from "@/services/storage/stem-splitter-session-storage";
import { StemSplitterCategory } from "@/data/stem-splitter-categories.constants";
import { useStartProcess } from "@/hooks/ai-tool-process/use-start-process";
import { useSplitterProgressContext } from "@/components/pages/stem-splitter/components/providers/stem-splitter-progress-provider";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { LicenseName } from "@/data/license.data";

export type StemSplitterConfig = {
  songFile: File | null;
  selectedCategories: StemSplitterCategory[];
};

const startSplitConfigCreator = (stemSplitterConfig: StemSplitterConfig) => {
  return {
    createConfigFormData: (formData: FormData) => {
      formData.append("songFile", stemSplitterConfig.songFile as Blob);
      formData.append(
        "categories",
        stemSplitterConfig.selectedCategories.join(","),
      );
    },
  };
};

export const useStartSplitter = () => {
  const progressContext = useSplitterProgressContext();
  const { showModal } = useGlobalModalContext();
  const showLimitedModal = (licenseName: LicenseName) =>
    showModal({
      type: "stem-splitter-count-limited_modal",
      props: {
        licenseName: licenseName,
      },
    });

  const { startAiProcess } = useStartProcess(
    (config: StemSplitterConfig) => startSplitConfigCreator(config),
    stemSplitterSessionStorage.pendingConfigStorage,
    "/api/split/file",
    progressContext,
    showLimitedModal,
  );

  return { startSplit: startAiProcess };
};
